import { render, staticRenderFns } from "./TransferDetail.vue?vue&type=template&id=d1458dd6&scoped=true"
import script from "./TransferDetail.vue?vue&type=script&lang=js"
export * from "./TransferDetail.vue?vue&type=script&lang=js"
import style0 from "./TransferDetail.vue?vue&type=style&index=0&id=d1458dd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1458dd6",
  null
  
)

export default component.exports